import { useState } from 'react'
import Head from 'next/head'
import FormSuccessDialog from '../components/FormSuccessDialog/FormSuccessDialog'
import FormErrorDialog from '../components/FormErrorDialog/FormErrorDialog'
import ContactFormContactPage from '../components/ContactForm/ContactFormContactPage'
import JsonLd from '../components/SEO/JsonLd'
import SEO from '../components/SEO/SEO'
import Layout from '../layout/Layout'
import classes from '../styles/section.module.css'
import useRecaptchaLoader from '../hooks/useRecaptchaLoader'

const ContactUs = () => {
  const [showSuccess, setShowSuccess] = useState(false)
  const [showError, setshowError] = useState(false)

  const toggleModal = () => {
    setshowError(false)
    setShowSuccess(false)
  }

  // Wrap the setters so we can log when they are toggled from child components
  const updateShowSuccess = value => {
    setShowSuccess(value)
  }

  const updateShowError = value => {
    setshowError(value)
  }
  // load recaptcha script on pages that need it
  const { loaded: recaptchaLoaded, error: recaptchaError } = useRecaptchaLoader()

  return (
    <>
      <SEO />
      <Head>
        <JsonLd data={{
          '@context': 'https://schema.org',
          '@type': 'ContactPage',
          name: 'Contact Evry Health',
          url: 'https://www.evryhealth.com/contact-us',
          mainEntity: {
            '@type': 'Organization',
            name: 'Evry Health',
            telephone: '+1-855-579-3879',
            email: 'support@evryhealth.com',
            address: {
              '@type': 'PostalAddress',
              addressLocality: 'Dallas',
              addressRegion: 'TX',
              addressCountry: 'US',
            },
          },
        }} />
      </Head>
      <Layout pageTitle="Evry Health - Better Health Insurance">
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="dfwSkyline.png"
                  alt="Dallas-Fort Worth skyline"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1 className="text-3xl tracking-tight md:text-5xl text-darkBlue">
                  Contact Us
                </h1>
                <p className="max-w-lg mt-6 text-xl text-grey sm:max-w-3xl">
                  We&#39;re here to answer all your questions.
                </p>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-6 py-12 mx-auto md:px-0">
            <div className="lg:grid lg:grid-cols-2 lg:gap-8">
              {showSuccess && (
                <FormSuccessDialog
                  click={e => {
                    setShowSuccess(false)
                  }}
                  toggleModal={toggleModal}
                />
              )}

              {showError && (
                <FormErrorDialog
                  click={e => {
                    setshowError(false)
                  }}
                  toggleModal={toggleModal}
                />
              )}
              <div>
                <ContactFormContactPage
                  updateShowSuccess={updateShowSuccess}
                  updateShowError={updateShowError}
                />
              </div>

              <div
                className={`lg:col-span-1 pl-0 ${classes.transformDFWMap} mt-8`}
              >
                <img src="dfw-map.png" alt="Map of DFW" />
                <div className="pt-16 text-lg text-grey">
                  <h2 className="pb-8 text-3xl leading-10 md:text-4xl text-blue-dark">
                    Headquartered in DFW and <br />
                    <span className="inline-block py-2">
                      serving the state of Texas.
                    </span>
                    <br />
                    <span className="inline-block py-2 text-globeGreen">
                      We&#39;re from here!
                    </span>
                  </h2>
                  <p className="pb-4 text-xl">
                    Call us:{' '}
                    <a href="tel:1-855-579-3879" className="font-bold">
                      1-855-579-3879
                    </a>
                  </p>
                  <p className="text-xl">
                    Email us:{' '}
                    <a
                      href="mailto:contact@evryhealth.com"
                      className="font-bold"
                    >
                      contact@evryhealth.com
                    </a>
                  </p>
                  {/* <p className="pt-4">
                    <object type="image/svg+xml" data="facebook-icon.svg" className="inline-block w-8 h-8 mr-2" />
                    <object type="image/svg+xml" data="instagram-icon.svg" className="inline-block w-8 h-8 mx-2" />
                    <object type="image/svg+xml" data="linkedin-icon.svg" className="inline-block w-8 h-8 mx-2" />
                    <object type="image/svg+xml" data="twitter-icon.svg" className="inline-block w-8 h-8 mx-2" />
                  </p> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default ContactUs
